/* certifiedpolska.pl — landing page
   Formularz zapisu (AJAX z fallbackiem na zwykły POST), odliczanie, sticky CTA, reveal. */
(() => {
  if (window.__cpLanding) return;
  window.__cpLanding = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const html = document.documentElement;

  const store = {
    get: (key) => {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    },
    set: (key, value) => {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {
        /* tryb prywatny: trudno, popup może wrócić */
      }
    },
  };

  /* ---------- formularz ---------- */

  /* Skąd przyszedł lead: UTM > przeglądarka wbudowana w aplikację > referrer. */
  const detectChannel = () => {
    const clean = (v) => v.toLowerCase().replace(/[^a-z0-9._-]/g, '').slice(0, 30);
    try {
      const params = new URLSearchParams(location.search);
      const utm = params.get('utm_source');
      if (utm) return clean(utm);
      if (params.get('ttclid')) return 'tiktok';
      if (params.get('fbclid')) return 'meta';
      const ua = navigator.userAgent || '';
      if (/musical_ly|BytedanceWebview|TikTok|trill/i.test(ua)) return 'tiktok';
      if (/Instagram/i.test(ua)) return 'instagram';
      if (/FBAN|FBAV/i.test(ua)) return 'facebook';
      if (document.referrer) return clean(new URL(document.referrer).hostname.replace(/^www\./, ''));
    } catch (e) {
      /* brak informacji o kanale to nie błąd */
    }
    return 'bezposrednio';
  };

  const buildTags = (form) => {
    const field = form.querySelector('[data-lp-tags]');
    if (!field) return;
    const picked = [...form.querySelectorAll('[data-lp-pref]:checked')].map((el) => el.value);
    const campaign = new URLSearchParams(location.search).get('utm_campaign');
    const extra = [`kanal-${detectChannel()}`];
    if (campaign) extra.push(`kampania-${campaign.toLowerCase().replace(/[^a-z0-9._-]/g, '').slice(0, 30)}`);
    field.value = [field.dataset.base, ...extra, ...picked].filter(Boolean).join(', ');
  };

  const showError = (form, message) => {
    const box = form.querySelector('[data-lp-error]');
    const input = form.querySelector('input[type="email"]');
    if (box) {
      box.textContent = message;
      box.hidden = !message;
    }
    if (input) {
      if (message) {
        input.setAttribute('aria-invalid', 'true');
        if (box && box.id) input.setAttribute('aria-describedby', box.id);
      } else {
        input.removeAttribute('aria-invalid');
      }
    }
  };

  const track = () => {
    document.dispatchEvent(new CustomEvent('landing:lead'));
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead');
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead');
      if (typeof window.ttq === 'object' && window.ttq.track) window.ttq.track('SubmitForm');
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'generate_lead' });
    } catch (e) {
      /* analityka nigdy nie może psuć zapisu */
    }
  };

  const markDone = (origin) => {
    document.querySelectorAll('[data-lp-form]').forEach((form) => {
      const body = form.querySelector('[data-lp-body]');
      const success = form.querySelector('[data-lp-success]');
      if (body) body.hidden = true;
      if (success) success.hidden = false;
    });
    document.documentElement.classList.add('lp-done');
    store.set('cp_lead', '1');
    document.querySelector('[data-lp-sticky]')?.classList.remove('is-visible');
    const success = origin.querySelector('[data-lp-success]');
    if (success) {
      success.focus({ preventScroll: true });
      if (success.getBoundingClientRect().top < 0 || success.getBoundingClientRect().bottom > window.innerHeight) {
        success.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    }
    track();
  };

  const submit = async (form) => {
    buildTags(form);
    showError(form, '');
    form.classList.add('is-loading');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      });

      if (response.url.includes('/challenge')) throw new Error('challenge');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const ok =
        response.url.includes('customer_posted=true') ||
        doc.querySelector('[data-lp-success]:not([hidden])');
      const err = doc.querySelector('[data-lp-error]:not([hidden])');

      if (ok) {
        markDone(form);
      } else if (err) {
        showError(form, err.textContent.trim());
      } else {
        throw new Error('unknown');
      }
    } catch (e) {
      /* sieć, captcha Shopify albo nieznana odpowiedź: oddajemy sprawę zwykłemu POST-owi */
      form.dataset.lpNative = 'true';
      form.submit();
      return;
    } finally {
      form.classList.remove('is-loading');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-lp-form]');
    if (!form || form.dataset.lpNative === 'true') return;
    event.preventDefault();
    if (form.classList.contains('is-loading')) return;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    submit(form);
  });

  /* ---------- udostępnianie ---------- */

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lp-share]');
    if (!button) return;
    const url = `${location.origin}${location.pathname}`;
    const text = button.dataset.shareText || document.title;
    const label = button.querySelector('.lp-btn__label');

    try {
      if (navigator.share) {
        await navigator.share({ title: document.title, text, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      if (label) {
        const original = label.textContent;
        label.textContent = button.dataset.labelDone || 'Skopiowane';
        setTimeout(() => (label.textContent = original), 2200);
      }
    } catch (e) {
      /* użytkownik zamknął okno udostępniania */
    }
  });

  /* ---------- odliczanie ---------- */

  const initCountdown = (root = document) => {
    root.querySelectorAll('[data-lp-countdown]').forEach((el) => {
      if (el.dataset.lpInit) return;
      el.dataset.lpInit = 'true';

      const target = new Date(el.dataset.lpCountdown.trim().replace(' ', 'T')).getTime();
      if (Number.isNaN(target)) return;

      const cells = {};
      el.querySelectorAll('[data-unit]').forEach((node) => (cells[node.dataset.unit] = node));
      const pad = (n) => String(n).padStart(2, '0');

      const tick = () => {
        const diff = target - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          return false;
        }
        const s = Math.floor(diff / 1000);
        cells.d.textContent = pad(Math.floor(s / 86400));
        cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
        cells.m.textContent = pad(Math.floor((s % 3600) / 60));
        cells.s.textContent = pad(s % 60);
        el.hidden = false;
        return true;
      };

      if (!tick()) return;
      const timer = setInterval(() => {
        if (!tick()) clearInterval(timer);
      }, 1000);
    });
  };

  /* ---------- reveal ---------- */

  let revealObserver;
  const initReveal = (root = document) => {
    const items = root.querySelectorAll('.lp-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    revealObserver =
      revealObserver ||
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    items.forEach((el) => revealObserver.observe(el));
  };

  /* ---------- sticky CTA (mobile) ---------- */

  const initSticky = () => {
    const bar = document.querySelector('[data-lp-sticky]');
    const heroForm = document.querySelector('[data-lp-form="quick"]');
    const signup = document.getElementById('zapis');
    if (!bar || !heroForm || !('IntersectionObserver' in window) || bar.dataset.lpInit) return;
    bar.dataset.lpInit = 'true';

    const seen = new Set();
    const update = () => {
      const hidden = document.documentElement.classList.contains('lp-done') || seen.size > 0;
      bar.classList.toggle('is-visible', !hidden);
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => (entry.isIntersecting ? seen.add(entry.target) : seen.delete(entry.target)));
      update();
    });
    observer.observe(heroForm);
    if (signup) observer.observe(signup);
  };

  /* ---------- delikatny tilt plakatu (tylko myszka) ---------- */

  const initTilt = (root = document) => {
    if (reduceMotion || !window.matchMedia('(hover: hover)').matches) return;
    root.querySelectorAll('.lp-hero__media').forEach((media) => {
      if (media.dataset.lpInit) return;
      media.dataset.lpInit = 'true';
      media.addEventListener('pointermove', (e) => {
        const r = media.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        media.style.setProperty('--ry', `${(x * 8).toFixed(2)}deg`);
        media.style.setProperty('--rx', `${(-y * 8).toFixed(2)}deg`);
      });
      media.addEventListener('pointerleave', () => {
        media.style.removeProperty('--rx');
        media.style.removeProperty('--ry');
      });
    });
  };

  /* ---------- popup z newsletterem ---------- */

  const initPopup = () => {
    const popup = document.querySelector('[data-lp-popup]');
    if (!popup || popup.dataset.lpInit) return;
    popup.dataset.lpInit = 'true';

    /* w edytorze motywu popup się nie wyskakuje sam */
    if (window.Shopify && window.Shopify.designMode) return;
    /* ktoś już się zapisał albo niedawno zamknął popup */
    if (store.get('cp_lead')) return;
    if (Number(store.get('cp_popup_until') || 0) > Date.now()) return;

    const delay = (Number(popup.dataset.delay) || 15) * 1000;
    const days = Number(popup.dataset.days) || 7;
    const card = popup.querySelector('.lp-popup__card');
    let shown = false;
    let lastFocus = null;

    const open = () => {
      if (shown || html.classList.contains('lp-done')) return;
      shown = true;
      lastFocus = document.activeElement;
      popup.hidden = false;
      html.classList.add('lp-popup-open');
      requestAnimationFrame(() => popup.classList.add('is-open'));
      card.focus({ preventScroll: true });
    };

    const close = () => {
      if (!shown) return;
      popup.classList.remove('is-open');
      html.classList.remove('lp-popup-open');
      setTimeout(() => (popup.hidden = true), reduceMotion ? 0 : 260);
      store.set('cp_popup_until', String(Date.now() + days * 86400000));
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };

    popup.addEventListener('click', (event) => {
      if (event.target.closest('[data-lp-popup-close]')) close();
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...card.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')].filter(
        (el) => !el.closest('[hidden]')
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    setTimeout(open, delay);

    /* przy próbie wyjścia (tylko komputery z myszką) */
    if (popup.dataset.exit === 'true' && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', (event) => {
        if (!event.relatedTarget && event.clientY <= 0) open();
      });
    }
  };

  /* ---------- start ---------- */

  const init = (root) => {
    initReveal(root);
    initCountdown(root);
    initSticky();
    initTilt(root);
    initPopup();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
